type AgeCategory =
  | "ADULTE"
  | "ETUDIANT"
  | "ADOLESCENT"
  | "ENFANT (-12 ans)"
  | "BABY (3-4 ans)";
type CourseType = "TAEKWONDO" | "BODY_TAEKWONDO" | "FEMININ";

type DobokSize = "SMALL" | "MEDIUM" | "LARGE";

type AdditionalFee = {
  id: string;
  title: string;
  type: "PASSPORT" | "DOBOK";
  price?: number;
  sizes?: {
    size: DobokSize;
    heights: string[];
    price: number;
  }[];
};

type PricingOption = {
  id: string;
  courseType: CourseType;
  title: string;
  categories: {
    category: AgeCategory;
    price: number;
  }[];
  additionalFees?: boolean;
};

export const additionalFeesData: AdditionalFee[] = [
  {
    id: "passport",
    title: "Passeport",
    type: "PASSPORT",
    price: 22,
  },
  {
    id: "dobok",
    title: "Dobok",
    type: "DOBOK",
    sizes: [
      {
        size: "SMALL",
        heights: ["1m10", "1m20", "1m30"],
        price: 45,
      },
      {
        size: "MEDIUM",
        heights: ["1m40", "1m50", "1m60"],
        price: 50,
      },
      {
        size: "LARGE",
        heights: ["1m70", "1m80", "1m90"],
        price: 55,
      },
    ],
  },
];

export const pricingData: PricingOption[] = [
  {
    id: "1",
    courseType: "TAEKWONDO",
    title: "TAEKWONDO",
    categories: [
      { category: "ADULTE", price: 335 },
      { category: "ETUDIANT", price: 315 },
      { category: "ADOLESCENT", price: 315 },
      { category: "ENFANT (-12 ans)", price: 295 },
      { category: "BABY (3-4 ans)", price: 275 },
    ],
    additionalFees: true,
  },
  {
    id: "2",
    courseType: "BODY_TAEKWONDO",
    title: "BODY TAEKWONDO SEUL",
    categories: [
      { category: "ADULTE", price: 145 },
      { category: "ADOLESCENT", price: 145 },
    ],
    additionalFees: false,
  },
  {
    id: "3",
    courseType: "FEMININ",
    title: "100% FÉMININ SEUL",
    categories: [
      { category: "ADULTE", price: 145 },
      { category: "ETUDIANT", price: 145 },
      { category: "ADOLESCENT", price: 145 },
    ],
    additionalFees: true,
  },
];
